// extracted by mini-css-extract-plugin
module.exports = {"section":"__404_section__kfR0f","seta":"__404_seta__uIzBS"};